/* eslint-disable max-len */
import React from 'react';
import { withRouter } from 'react-router-dom';


import EmptyState from 'src/components/EmptyState';
import HttpLedger from 'src/components/HttpLedger';
import Label from 'src/components/Label';
import RelativeDate from 'src/components/RelativeDate';
import EngagementNameCell from 'src/components/cells/EngagementNameCell';
import EngagementStatusCell from 'src/components/cells/EngagementStatusCell';

function EngagementsLedger() {
  const columns = [
    {
      title: 'Name',
      cellContent: (result: any) => <EngagementNameCell engagement={result} />,
    },
    {
      title: 'Current step',
      cellContent: (result: any) => <Label color="warning">{result.stepName}</Label>,
    },
    {
      title: 'Last activity',
      cellContent: (result: any) => <RelativeDate datetime={result.lastActivity} />,
    },
    {
      title: 'Status',
      cellContent: (result: any) => <EngagementStatusCell engagement={result} />,
    },
  ];

  return (
    <HttpLedger
      url="/automatic/engagements/"
      columns={columns}
      emptyState={<EmptyState />}
      isPaginated
      isSearchable
    />
  );
}

EngagementsLedger.propTypes = {
};

EngagementsLedger.defaultProps = {
};

export default withRouter(EngagementsLedger);
